import actions from './actions'

const initialState = {
  counties: [],
  sports: [],
  roles: [],
  country: {},
  user: {},
  loggedInAsAdmin: false,
  permissions: [],
  isUserLoaded: false,
  loadingDetails: false,
  authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
  errors: {}
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state
  }
}
